/**
 * Celeste pseudo box shared constants
 */
export const CELESTE_PSEUDO_VIEWBOX = '0 0 307 100';
